import React, {useContext, useEffect, useState} from "react";

import * as layout from "../_redux/layoutRedux";
import {connect, shallowEqual, useSelector} from "react-redux";
import NotificationsDropdown from "./NotificationsDropdown";
import {get_active_languages, get_log_jobs, get_menu_items,get_new_menu_items, get_my_permissions, sign_out} from "../_redux/layoutCrud";
import {useHistory} from "react-router-dom";
import TopMenu from "./TopMenu";
import DashboardDropdown from "./DashboardDropdown";
import LanguageDropdown from "./LanguageDropdown";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {config} from "../../../config/config";
import {AppConfig} from "../../../appConfig";
// import inboxState from "../../../views/inbox/_redux/inboxRedux";

function Header(props) {
    const [collapsedHeader, setCollapsedHeader] = useState(true);
    const {apiServer} = useContext(AppConfig)
    let {state} = useSelector(
        (state) => ({
            state: state.layout2
        }),
        shallowEqual
    );

    let {inboxState}=useSelector(
        (state) => ({
            inboxState: state.inbox
        }),
        shallowEqual
    )
    if (state === undefined) state = {};
    let history = useHistory();
    useEffect(() => {
        if (state.is_top_menu_loading === 0) {
            let lang = localStorage.getItem('lang');
            if(lang === null) lang = 'fa'
            getMenuData();
            get_menu_items(apiServer,lang).then(res => {
                props.bi_menu_items_loaded(res.bi_menu)
            })
            get_my_permissions(apiServer).then(res => {
                let permissions = res.map(x=>x.PER_CODE.toUpperCase())
                props.handle_variables('user_permissions', permissions);
            })
            get_log_jobs().then(res => {
                if (res.data.data !== undefined) {
                    props.handle_variables('log_job_labels', res.data.data);
                }
            });

            if(config.multi_lang === true){
                get_active_languages().then(res => {
                    props.active_lang_loaded(res)
                })
            }
            props.handle_variables('is_top_menu_loading', 1);

        }
    });

    useEffect(()=>{
        if(state.isMenuChange){
            getMenuData();
            props.handle_variables('isMenuChange',false)
        }
    },[state.isMenuChange])

    useEffect(()=>{
        getMenuData(state.menuChangeByAction);
    },[state.menuChangeByAction])
    

    const getMenuData=(action="todo")=>{
        //inboxState.current_action
        if(!state.not_inbox) {
            get_new_menu_items(apiServer, action)
                .then(res => {
                    // orderdRes=res.sort((a, b) => a.order - b.order);
                    let bpms_categories = [];

                    res.length > 0 && res.map(x => {
                        let menu = {};
                        menu.title = x.label;
                        menu.descrption = '';
                        menu.icon = x.icon;
                        menu.new = "1";
                        let orderedItems = [];
                        orderedItems = x.items.sort((a, b) => a.order - b.order);
                        menu.items = [];
                        orderedItems.map(y => {
                            let menuItems = {};
                            menuItems.title = y.label;
                            menuItems.descrption = y.description;
                            menuItems.pro_descrption = "";
                            menuItems.icon = "";
                            menuItems.route = `outlook/create/${y.pro_uid}/${y.task_uid}`;
                            menuItems.route_type = "internal";
                            menuItems.new = "1";
                            menuItems.unread_count = "0"
                            menuItems.pro_uid = y.pro_uid;
                            menuItems.tas_uid = y.task_uid;
                            menuItems.can_start = y.can_start ? "1" : "0";
                            menu.items.push(menuItems);
                        })
                        bpms_categories.push(menu);
                    })
                    props.menu_items_loaded(bpms_categories);
                    if (bpms_categories.length > 0)
                        props.handle_variables('current_category', bpms_categories[0])
                })
        }
    }

    const handle_sign_out = () => {
        sign_out().finally(res => {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            let lang = localStorage.getItem('lang');
            let def_lang = localStorage.getItem('default_lang');
            if(def_lang === null) def_lang = "fa";
            if(lang === "undefined") localStorage.setItem('lang',def_lang);
            window.location.replace( "#"+config.firstRedirectUrl);
            // history.push('/login');
        })
    }
    if (state.is_case_detail === true || state.is_bi_dashboard === true || state.not_inbox === true)
        return (<div className={'case-header-container' + (collapsedHeader === true ? ' collapsed' : '')}>
            <div className={'header-container' + (state.is_sidebar_collapsed === true ? ' collapsed' : '')}>
                <TopMenu items={state.top_menu_items}/>
                <div className={'header-left-container'}>
                    <LanguageDropdown />
                    <DashboardDropdown/>
                    {/*<NotificationsDropdown/>*/}
                    <div className={'notification-dropdown-btn'}
                         onClick={() => handle_sign_out()}
                        title={props.t('Sign out')}
                    >
                        <i className="fal fa-door-open"></i>
                    </div>
                    {!collapsedHeader && 
                    <div className={'case-header-btn'}  onClick={() => setCollapsedHeader(!collapsedHeader)}>
                        <i className="fas fa-arrow-up fa-2x"></i>
                    </div>}
                    
                </div>
            </div>
            {collapsedHeader && 
            <div className={'case-header-btn'}  onClick={() => setCollapsedHeader(!collapsedHeader)}>
                    <i className="fas fa-arrow-down fa-2x"></i>
            </div>}
        </div>)

    return (<div className={'header-container' + (state.is_sidebar_collapsed === true ? ' collapsed' : '')}>
        <TopMenu items={state.top_menu_items}/>
        <div className={'header-left-container'}>
        <LanguageDropdown />
            <DashboardDropdown/>
            {/*<NotificationsDropdown/>*/}
            <div className={'notification-dropdown-btn'}
                 onClick={() => handle_sign_out()}
                 title={props.t('Sign out')}
            >
                <i className="fal fa-door-open"></i>
            </div>
            {/*<div className={'text-center date-holder'}>*/}
            {/*    <h6><small>{current_date}</small></h6>*/}
            {/*    <h6><small>{current_time}</small></h6>*/}
            {/*</div>*/}
        </div>
    </div>)
}
export default compose(
    withTranslation(),
    connect(null, layout.actions)
)(Header);
